<footer class="app-footer">
    <span><a href="https://eastexcrude.com" target="_blank">Eastex Crude</a> &copy; {{year}} &nbsp;</span>
    <span><small>v:{{appVersionNumber}}</small></span>
</footer>
